import { StaticImage } from "gatsby-plugin-image";
import React, { useEffect } from "react";
import '../../sass/components/flexibleModules/_components.customhtml.scss';

const CustomHtmlComponent = ({ data }) => {

    useEffect(() => {
        // if (data.greenhouseOrGeneral === 'greenhouse') {
        //     var s = document.createElement('script');
        //     s.type = 'text/javascript';
        //     s.async = true;
        //     s.contentType = 'text/javascript';
        //     s.src = '//boards.greenhouse.io/embed/job_board/js?for=hostanalytics';
        //     document.getElementsByTagName('body')[0].appendChild(s);
        // }
        if (data.greenhouseOrGeneral === 'optimize') {
            var salt = document.createElement('script');
            salt.type = 'text/javascript';
            salt.async = true;
            salt.contentType = 'text/javascript';
            salt.src = '//www.googleoptimize.com/optimize.js?id=OPT-K79N5GK';
            document.getElementsByTagName('head')[0].appendChild(salt);
        }
        if (data.greenhouseOrGeneral === 'trustradius') {
            var trustScript = document.createElement('script');
            trustScript.type = 'text/javascript';
            trustScript.async = true;
            trustScript.src = '//www.trustradius.com/trustquotes/trustquotes.js';
            document.getElementsByTagName('head')[0].appendChild(trustScript);
        }
    }, []);

    return (
        <div className={`cp-flexibleCustomhtml l-app${data.greenhouseOrGeneral}`} style={{ backgroundColor: `${data.backgroundColor}` }}>
            <div className="cp-flexibleCustomhtml__inner" style={{ maxWidth: `${data.maxWidth}px`, margin: "0 auto" }}>
                {data.customHtml &&
                    <>
                        {data.greenhouseOrGeneral === 'trustradius' &&
                            <>
                                <h2>FP&amp;A Pros love us on</h2>
                                <StaticImage src='../../images/trust-radius.svg' alt="Trust Radius" />
                            </>
                        }
                        <div dangerouslySetInnerHTML={{ __html: data.customHtml }} />
                    </>
                }
            </div>
        </div>
    )
}

export default CustomHtmlComponent;